import { render, staticRenderFns } from "./ClasesIngresarNota.vue?vue&type=template&id=fc4f59ec&"
import script from "./ClasesIngresarNota.vue?vue&type=script&lang=js&"
export * from "./ClasesIngresarNota.vue?vue&type=script&lang=js&"
import style0 from "./ClasesIngresarNota.vue?vue&type=style&index=0&id=fc4f59ec&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports